import React, { Component } from 'react';
import ErrorInfo from './error-info';
import Loading from './loading';

import { withSnackbar } from 'notistack';

class AsyncComponent extends Component {

  state = { Component: null, failed: false };

  cleanProps() {
    const { component, def, FailComponent, ...cleanProps } = this.props;

    return cleanProps;
  }

  enqueueSnackbar(...props) {
    return this.props.enqueueSnackbar && this.props.enqueueSnackbar(...props);
  }

  componentDidMount() {
    this.mounted = true;

    return Promise
      .resolve(this.props.component(this.cleanProps()))
      .then(C => this.mounted && C && this.setState({ Component: C.default || C }))
      .catch(({ message, ...info }) => {
        this.enqueueSnackbar(message, { variant: 'error' });

        return this.mounted && this.setState({failed: { message, info }});
      });
  }

  componentWillUnmount() {
    return this.mounted = false;
  }

  render() {
    const { Component, failed } = this.state;
    const { FailComponent } = this.props;

    return failed
      ? <FailComponent {...failed} />
      : typeof Component === 'function' ? <Component {...this.cleanProps()} /> : this.props.def;
  }
}

const loading = <Loading open={true} />;

export const Async = (component, def = loading, failResolver = ErrorInfo) => function Async(props) {
  return <AsyncComponent component={component} def={def} FailComponent={failResolver} {...props} />;
};

export default (component, def = loading, failResolver = ErrorInfo) => withSnackbar(
  function Async(props) {
    return <AsyncComponent
      component={component}
      def={def}
      FailComponent={failResolver}
      {...props}
    />;
  }
);
